import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../context/LanguageContext';

const SEOHead = ({ pageSlug = 'home', customTitle, customDescription }) => {
  const { language } = useLanguage();
  
  const defaultTitles = {
    home: 'BACC - Brasil Asia Chamber of Commerce',
    sobre: 'Quem Somos | BACC',
    servicos: 'Serviços | BACC',
    cursos: 'Cursos | BACC',
    eventos: 'Eventos | BACC',
    blog: 'Blog | BACC',
    contato: 'Contato | BACC',
    associacao: 'Associação | BACC',
    parceiros: 'Parceiros | BACC'
  };

  const title = customTitle || defaultTitles[pageSlug] || 'BACC - Brasil Asia Chamber of Commerce';
  const description = customDescription || 'Conectando Brasil e Ásia através de negócios, cultura e diplomacia econômica.';

  return (
    <Helmet>
      <html lang={language} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
    </Helmet>
  );
};

export default SEOHead;
